import { toast } from 'sonner'

/** Zo lang staat "Ongedaan maken" in beeld: lang genoeg om de fout te zien, kort genoeg om niet te storen. */
const UNDO_MS = 8000

type Options = {
  /** Wat er verder gebeurt, bijv. "Pas definitief als je opslaat." */
  description?: string
  /** Melding na herstellen. Standaard "Teruggezet". */
  restored?: string
}

/**
 * De vergevingsgezinde kant van elke destructieve actie in het beheer: doe het meteen,
 * en bied een paar seconden "Ongedaan maken". Zo hoeft er geen "Weet je het zeker?"
 * tussen te staan bij dingen die in het concept gebeuren.
 *
 * `restore` moet zelf veilig zijn tegen tussentijdse wijzigingen (functionele update
 * op de nieuwste stand), niet een oude kopie terugzetten.
 */
export function undoToast(title: string, restore: () => void, { description, restored = 'Teruggezet' }: Options = {}) {
  let done = false
  const id = toast(title, {
    description,
    duration: UNDO_MS,
    action: {
      label: 'Ongedaan maken',
      onClick: () => {
        // Sonner kan een klik twee keer doorgeven bij een snelle dubbeltik.
        if (done) return
        done = true
        restore()
        toast.success(restored, { id })
      },
    },
  })
  return id
}
